import { render } from "./EventModal.vue?vue&type=template&id=1ac75182&scoped=true"
import script from "./EventModal.vue?vue&type=script&lang=js"
export * from "./EventModal.vue?vue&type=script&lang=js"

import "./EventModal.vue?vue&type=style&index=0&id=1ac75182&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1ac75182"

export default script